<template>
    <div>

        <Head title="Create Sales Order" />
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-orange-400 hover:text-orange-600" href="/orders-failed-deliveries">Failed Deliveries
            </Link>
        </h1>
        <div class="bg-white rounded-md shadow">
            <form>
                <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
                    <h1 class="text-2xl font-bold">
                        {{ orderObj.order_no }} - {{ orderObj.name }}/ [{{ orderObj.status }}]
                    </h1>
                </div>
                <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
                    <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
                        <div class="grid grid-cols-1 gap-4 p-1">
                            <div class="pt-2 p-2">
                                <h1 style="font-size: 18px; font-weight: bold">Product Details</h1>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4 overflow-x-auto">
                        <table class="w-full whitespace-nowrap">
                            <tr class="text-left font-bold">
                                <th class="pb-3 pt-3 px-3">#</th>
                                <th class="pb-3 pt-3 px-3">SKU</th>
                                <th class="pb-3 pt-3 px-3">Description</th>
                                <th class="pb-3 pt-3 px-3">Quantity</th>
                                <th class="pb-3 pt-3 px-3">Unit Price</th>
                                <th class="pb-3 pt-3 px-3">Discount (%)</th>
                                <th class="pb-3 pt-3 px-3 text-end float-right">Amount</th>
                            </tr>
                            <tr v-for="(item, index) in details" :key="index">
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-center px-3">{{ index + 1 }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-left px-3">{{ item.sku }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3" style="
                      word-wrap: break-word !important;
                      word-break: break-all !important;
                      white-space: normal !important;
                      width: 30%;
                    ">
                                    <span class="flex items-left px-3">{{ item.description }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-center justify-center px-3">{{
                                        item.quantity
                                    }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-center justify-center px-3">{{
                                        item.unit_cost
                                    }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-center justify-center px-3">{{
                                        item.discount
                                    }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-end px-3 text-end justify-end">{{
                                        item.amount
                                    }}</span>
                                </td>
                            </tr>
                            <tr v-if="orderObj.delivery_fees && orderObj.delivery_fees > 0">
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-left px-3">{{ details.length + 1 }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-left px-3">{{
                                        orderObj.transport_name
                                    }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-left px-3">{{
                                        orderObj.transport_description
                                    }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-center justify-center px-3">1</span>
                                </td>
                                <td class="w-px pb-3 pt-3 border-t border-b">
                                    <span class="flex items-center justify-center px-3">{{
                                        orderObj.transport_amount
                                    }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-center justify-center px-3">0</span>
                                </td>
                                <td class="w-px pb-3 pt-3 border-t border-b">
                                    <span class="flex items-end px-3 items-end justify-end">{{
                                        orderObj.transport_amount
                                    }}</span>
                                </td>
                            </tr>
                            <tr>
                                <th class="pb-3 pt-3 border-t border-b">Total</th>
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b">
                                    <span class="flex items-end px-3 items-end justify-end">{{
                                        orderObj.amount
                                    }}</span>
                                </th>
                            </tr>
                        </table>
                    </div>
                    <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4 mt-2">
                        <div class="grid grid-cols-1 gap-4 p-1">
                            <div class="pt-2 p-2">
                                <h1 style="font-size: 18px; font-weight: bold">Payment Details</h1>
                            </div>
                        </div>
                    </div>
                    <div v-if="orderObj.payments && orderObj.payments.length > 0" class="mb-4 overflow-x-auto">
                        <table class="w-full whitespace-nowrap">
                            <tr class="text-left font-bold">
                                <th class="pb-3 pt-3 px-3">#</th>
                                <th class="pb-3 pt-3 px-3">Date</th>
                                <th class="pb-3 pt-3 px-3">Payment Mode</th>
                                <th class="pb-3 pt-3 px-3">Reference</th>
                                <th class="pb-3 pt-3 px-3">Initiated By</th>
                                <th class="pb-3 pt-3 px-3">Phone Number</th>
                                <th class="flex items-end px-3 items-end justify-end">Amount</th>
                            </tr>
                            <tr v-for="(item, index) in orderObj.payments" :key="index">
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-center px-3">{{ index + 1 }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-left px-3">{{ item.date }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-left px-3">{{ item.provider }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3 break-all" style="
                      word-wrap: break-word !important;
                      word-break: break-all !important;
                      white-space: normal !important;
                      width: 30%;
                    ">
                                    <p class="px-3">{{ item.reference }}</p>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-center px-3">{{ item.user }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-center px-3">{{ item.phone_number }}</span>
                                </td>
                                <td class="w-px border-t pb-3 pt-3">
                                    <span class="flex items-end px-3 items-end justify-end">{{
                                        item.amount
                                    }}</span>
                                </td>
                            </tr>
                            <tr>
                                <th class="pb-3 pt-3 border-t border-b">Total</th>
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b" />
                                <th class="pb-3 pt-3 border-t border-b">
                                    <span class="flex items-end px-3 items-end justify-end">{{
                                        orderObj.total_payments
                                    }}</span>
                                </th>
                            </tr>
                        </table>
                    </div>
                    <div v-else class="p-2">
                        No order payment details not found.
                    </div>
                    <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4 mt-2">
                        <div class="grid grid-cols-1 gap-4 p-1">
                            <div class="pt-2 p-2">
                                <h1 style="font-size: 18px; font-weight: bold">Reason</h1>
                            </div>
                        </div>
                    </div>
                    <div class="p-2">{{ orderObj.delivery_failure_reason }}</div>
                </div>
                <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <span v-if="
                        user.group_permissions.includes('update_failed_deliveries') ||
                        user.per_user_permissions.includes('update_failed_deliveries') ||
                        user.role === 'admin'
                    " class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                        <button type="button"
                            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                            @click="openModal('Cancel')">
                            Cancel Delivery
                        </button>
                    </span>
                    <span v-if="
                        user.group_permissions.includes('update_failed_deliveries') ||
                        user.per_user_permissions.includes('update_failed_deliveries') ||
                        user.role === 'admin'
                    " class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                        <button type="button"
                            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                            @click="openModal('Reschedule')">
                            Schedule Delivery
                        </button>
                    </span>
                </div>
            </form>
        </div>
    </div>
    <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity">
                <div class="absolute inset-0 bg-gray-500 opacity-75" />
            </div>
            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
            <div class="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl w-full"
                role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                <form @submit.prevent="updateOrder">
                    <!-- Modal header -->
                    <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6">
                        <h1 class="text-3xl font-bold mb-4">{{ form.action_option }} Delivery</h1>
                    </div>
                    <!-- Modal body -->
                    <div class="bg-white px-4 py-3 sm:px-6 md:px-6">

                        <!-- Fail Options -->
                        <div v-show="false" class="w-full mb-4">
                            <label class="block mb-1 font-semibold">Action Options</label>
                            <multiselect v-model="form.action_option" placeholder="Search Options"
                                :options="reasonOptions" :close-on-select="true" :searchable="true" :class="w - full"
                                :error="form.errors.action_option"
                                :style="form.errors.action_option ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                                @input="onSelectedFailureOption" />
                            <span class="mt-1 block text-red-600 text-sm">{{ form.errors.action_option }}</span>
                        </div>

                        <!-- Reasons -->
                        <div class="w-full mb-4">
                            <label class="block mb-1 font-semibold">Reasons</label>
                            <multiselect v-model="form.reason" placeholder="Search Reasons" :options="reasonOptions"
                                :close-on-select="true" :searchable="true" :class="w - full" :error="form.errors.reason"
                                :style="form.errors.reason ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''" />
                            <span class="mt-1 block text-red-600 text-sm">{{ form.errors.reason }}</span>
                        </div>

                        <!-- Reschedule Date -->
                        <div v-if="form.action_option === 'Reschedule'" class="w-full mb-4">
                            <label class="block mb-1 font-semibold">Reschedule Date</label>
                            <text-input v-model="form.reschedule_date" class="w-full" type="date"
                                :error="form.errors.reschedule_date" placeholder="Reschedule date" />
                        </div>

                    </div>

                    <!-- Modal footer -->
                    <div class="bg-gray-50 px-4 py-3 sm:px-6 flex flex-col sm:flex-row sm:justify-end sm:space-x-3">
                        <!-- Close Button -->
                        <button type="button" @click="closeModal"
                            class="w-full sm:w-auto mt-3 sm:mt-0 inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-white text-orange font-medium text-gray-700 shadow-sm hover:bg-orange-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                            Close
                        </button>
                        <!-- Submit Button -->
                        <loading-button :loading="form.processing"
                            class="w-full sm:w-auto inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-orange-600 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
                            type="submit">
                            Submit
                        </loading-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        TextInput,
        Multiselect,
        SelectInput,
    },
    layout: Layout,
    remember: 'form',
    props: {
        orderObj: Object,
        details: Array,
        cancelationReasons: Array,
        rescheduleReasons: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                action_option: null,
                reason: null,
                reschedule_date: null,
                order_id: null
            }),
            isOpen: false,
            reasonOptions: [],
            failOptions: [
                {
                    label: 'Reschedule',
                    value: 'Reschedule'
                },
                {
                    label: 'Cancel',
                    value: 'Cancel'
                }
            ],
        }
    },
    computed: {
        user() {
            return this.$inertia.page.props.auth.user;
        },
    },
    methods: {
        openModal(string) {
            this.form.action_option = string
            if (string === "Reschedule") {
                this.reasonOptions = this.cancelationReasons
            }

            if (string === "Cancel") {
                this.reasonOptions = this.cancelationReasons
            }
            this.isOpen = true;
            this.form.order_id = this.orderObj.id
            this.form.delivery_date = this.orderObj.delivery_date
        },
        closeModal() {
            this.isOpen = false;
        },
        onSelectedFailureOption(option, id) {
            this.reasonOptions = []
            if (option === "Reschedule") {
                this.reasonOptions = this.cancelationReasons
            }

            if (option === "Cancel") {
                this.reasonOptions = this.cancelationReasons
            }
        },
        updateOrder() {
            this.form._method = 'post'
            this.form.post(`/orders-failed-deliveries`, {
                onSuccess: () => {
                    this.form.reset()
                    this.isOpen = false
                },
                onError: (error) => {
                },
            })
        },
    },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
.multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed, #fb923c);
    color: var(--ms-option-color-selected-pointed, #fff);
}

.multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed, #fb923c);
    color: var(--ms-option-color-selected-pointed, #fff);
}
</style>